export default __webpack_public_path__ + "static/media/s2img1.45b7f2b5.png";